import { render, staticRenderFns } from "./NuevaOrdenCompra.vue?vue&type=template&id=708328f0&scoped=true"
import script from "./NuevaOrdenCompra.vue?vue&type=script&lang=js"
export * from "./NuevaOrdenCompra.vue?vue&type=script&lang=js"
import style0 from "spinkit/spinkit.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./NuevaOrdenCompra.vue?vue&type=style&index=1&id=708328f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "708328f0",
  null
  
)

export default component.exports